import { render, staticRenderFns } from "./RadioGroupComponent.vue?vue&type=template&id=7481780c"
import script from "./RadioGroupComponent.vue?vue&type=script&lang=js"
export * from "./RadioGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports